import { useMutation } from 'react-query';
import { Http } from '../../services/Http';
import { MUTATION_KEYS } from '../constants';
import { useInvalidateUsers } from './useUsers';
import { User } from '../../types';
import { useInvalidateFilteredOpsTimesheets } from './useFilteredOpsTimesheets';

async function resetUserTimesheets(userId: number): Promise<User> {
  const { data } = await Http.axios.put<null, User>(`/user/reset-timesheets/${userId}`);
  return data;
}

export const useResetUserTimesheets = () => {
  const invalidateUsers = useInvalidateUsers();
  const invalidateUserOperatingPartners = useInvalidateFilteredOpsTimesheets();

  return useMutation(resetUserTimesheets, {
    mutationKey: MUTATION_KEYS.RESET_USER_KEY,
    onSuccess: () => {
      invalidateUsers();
      invalidateUserOperatingPartners();
    },
  });
};
